// extracted by mini-css-extract-plugin
module.exports = {"container":"openaccount_container__1uFlE","heading":"openaccount_heading__1JO8x","textsection":"openaccount_textsection__3lUjK"};